import AmenitiesBento from "@/components/AmenitiesBento";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

export default function AmenitiesPage() {
  useDocumentMeta();
  return (
    <>
      <section className="max-w-7xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-8" data-testid="amenities-hero">
        <div className="overline">The park</div>
        <h1 className="font-serif text-5xl sm:text-6xl md:text-7xl tracking-tight leading-[0.95] mt-4 max-w-4xl">
          A family-friendly caravan park <em className="italic font-light">in Victoria.</em>
        </h1>
        <p className="mt-6 text-sa-ink2 text-lg max-w-2xl leading-relaxed">
          Twelve acres of deliberately calm bushland. We've designed every amenity around one idea: travel should feel restorative.
          From clean bathrooms to a seasonal pool, the everyday things at our Ballarat caravan park just work — so you can focus on the rest.
        </p>
      </section>

      <AmenitiesBento />

      <section className="max-w-7xl mx-auto px-6 md:px-10 py-24">
        <div className="bg-white border border-sa-ink/10 rounded-3xl p-12 md:p-16 grid md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-7">
            <div className="overline">Long-stay & FIFO</div>
            <h2 className="font-serif text-3xl sm:text-4xl tracking-tight mt-3">
              Project workers, contractors and slow travellers — welcome.
            </h2>
            <p className="mt-4 text-sa-ink2 leading-relaxed">
              Weekly and monthly rates, dedicated quiet zones, on-site laundry and secure parking.
              Tell us a bit about your project and we'll put together a private quote — see all{" "}
              <Link to="/accommodation" className="text-sa-accent hover:text-sa-accentHover">accommodation in Ballarat</Link> first.
            </p>
          </div>
          <div className="md:col-span-5 flex md:justify-end">
            <Link to="/contact" className="btn-primary" data-testid="long-stay-cta">
              Request a long-stay quote <ArrowRight size={16} weight="bold" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

